module.exports = __webpack_public_path__ + "static/media/CAIXA.2d57913a.svg";